import { albumsReducer } from '@adminStore/albums';
import { dashboardReducer } from '@adminStore/dashboard';
import { documentsReducer as adminDocumentsReducer } from '@adminStore/documents';
import { eventsReducer as adminEventsReducer } from '@adminStore/events';
import { guestsReducer } from '@adminStore/guests';
import { rewardLogsReducer } from '@adminStore/reward-logs';
import { rewardsReducer } from '@adminStore/rewards';
import { tagsReducer } from '@adminStore/tags';
import { usersReducer } from '@adminStore/users';
import { workLogsReducer } from '@adminStore/work-logs';
import { workTypesReducer } from '@adminStore/work-types';
import { productCategoriesReducer } from '@adminStore/product-categories';
import { productsReducer } from '@adminStore/products';
import { posSessionsReducer } from '@adminStore/pos-sessions';
import { linksReducer } from '@adminStore/links';
import { appSettingsReducer } from '@adminStore/app-settings';
import { extraExpensesReducer } from '@adminStore/extra-expenses';
import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { userReducer } from '@store/user/user.reducer';

export const appReducers: ActionReducerMap<AppState> = {
  user: userReducer,
  adminUsers: usersReducer,
  adminEvents: adminEventsReducer,
  adminTags: tagsReducer,
  adminGuests: guestsReducer,
  adminAlbums: albumsReducer,
  adminWorkTypes: workTypesReducer,
  adminRewards: rewardsReducer,
  adminWorkLogs: workLogsReducer,
  adminRewardLogs: rewardLogsReducer,
  adminDashboard: dashboardReducer,
  adminDocuments: adminDocumentsReducer,
  adminProductCategories: productCategoriesReducer,
  adminProducts: productsReducer,
  adminPosSessions: posSessionsReducer,
  adminLinks: linksReducer,
  adminAppSettings: appSettingsReducer,
  adminExtraExpenses: extraExpensesReducer,
};
